module.exports = __webpack_public_path__ + "img/恢复设置.312ff559.svg";